import React, { useEffect, useRef, useState, useContext } from "react";
import "./css/SendInputTextBox.css";
import CurrentMissionContext from "./CurrentMissionContext";
import ISO6391 from "iso-639-1";

window.ReactInterface = {};

const SendInputTextBox = () => {
  const [text, setText] = useState(" ");
  const [npc, setNpc] = useState(null);
  const [isInputOpen, setIsInputOpen] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [finalTranscript, setFinalTranscript] = useState("");
  const [interimTranscript, setInterimTranscript] = useState("");
  const inputRef = useRef(null);
  const recognition = useRef(null);
  const currentMission = useContext(CurrentMissionContext);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.gameInstance) {
        window.ReactInterface.openPrompt = (_npc) => {
          // window.gameInstance.events.emit('disable-keyboard');
          setNpc(_npc);
          setText(_npc.talk);
          setIsInputOpen(true);
        };
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // console.log("current Mission", currentMission);
    if ("webkitSpeechRecognition" in window) {
      recognition.current = new window.webkitSpeechRecognition();

      let language = "English";
      try {
        language = currentMission.Language;
      } catch (error) {
        console.log("Error retrieving language from currentMission:", error);
        const selectedMission = localStorage.getItem("selectedMission");
        if (selectedMission) {
          try {
            const parsedMission = JSON.parse(selectedMission);
            language = parsedMission.Language;
          } catch (error) {
            console.error(
              "Error parsing selectedMission from localStorage:",
              error
            );
          }
        }
      }

      console.log("language", language);

      // Convert the language name to ISO 639-1 code
      const languageCode = ISO6391.getCode(language);

      // If the language is not found, default to English
      recognition.current.lang = languageCode || "en-US";

      recognition.current.continuous = true;
      recognition.current.interimResults = true;

      recognition.current.onresult = (event) => {
        let interim = "";
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            setFinalTranscript(
              (finalTranscript) =>
                finalTranscript + event.results[i][0].transcript
            );
          } else {
            interim += event.results[i][0].transcript;
          }
        }
        setInterimTranscript(interim);
      };

      recognition.current.onend = () => {
        if (isListening) {
          recognition.current.start();
        }
      };
    } else {
      console.error("Speech recognition is not supported in this browser.");
    }
  }, [isListening, currentMission]);

  useEffect(() => {
    setText(finalTranscript + interimTranscript);
  }, [finalTranscript, interimTranscript]);

  useEffect(() => {
    if (isInputOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isInputOpen]);

  const sendPrompt = () => {
    window.gameInstance.submitPrompt(text, npc);
    window.gameInstance.events.emit("enable-keyboard");
    setIsInputOpen(false);
    setFinalTranscript("");
    setInterimTranscript("");
    setText(""); // You may also want to clear the text here
  };

  const cancelPrompt = () => {
    window.gameInstance.events.emit("enable-keyboard");
    setIsInputOpen(false);
    setFinalTranscript("");
    setInterimTranscript("");
    setText(""); // You may also want to clear the text here
  };

  const handleKeyDown = (event) => {
    event.stopPropagation();
  };

  const handleKeyUp = (event) => {
    event.stopPropagation();
  };

  const toggleListening = () => {
    setIsListening(!isListening);
    if (!isListening) {
      recognition.current.start();
    } else {
      recognition.current.stop();
      setFinalTranscript("");
      setInterimTranscript("");
    }
  };

  return (
    <div className="helper-tools send">
      {isInputOpen && (
        <div className="interactive-text-box">
          <div className="send-form">
            <textarea
              id="game-input"
              ref={inputRef}
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={handleKeyDown}
              onKeyUp={handleKeyUp}
            />
            <div className="send-buttons">
              <button onClick={sendPrompt}>Send</button>
              <button onClick={cancelPrompt}>Cancel</button>
              <button onClick={toggleListening}>
                <img
                  src="./assets/microphone.svg"
                  alt="Microphone"
                  width="30"
                  height="30"
                />
                {isListening && "..."}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SendInputTextBox;
